import React from 'react'
import RecognizeTeam from '../../../images/converseValues/800504-P01_FA22_Progress_03553_EL_JHolder_Metcon8 1.png'

const Team = () => {
	return (
		<div className='about-maxims section-container' style={{ margin: '32px 0px 64px', padding: '0 65px' }}>
			<div className='ncss-col-sm-6 section-block' style={{ maxWidth: '610px', minWidth: '380px' }}>
				<h1 className='section-title'>Let’s recognize our team</h1>
				<p className='section-p'>
					Recognize your teammates for their hard work, innovative spirit and embodiment of the Nike Maxims! The Nike High
					Five program empowers you to acknowledge good work when you see it!
				</p>
			</div>
			<div className='ncss-col-sm-6 section-block'>
				<img
					src={RecognizeTeam}
					alt='Recognize Team Work'
					style={{
						borderRadius: '16px',
						minWidth: '380px',
						height: 'auto',
					}}
				/>
			</div>
		</div>
	)
}

export default Team



// WEBPACK FOOTER //
// ./src/containers/AboutPage/ConverseValues/Team.js